import { mapKeys } from 'lodash';

async function getBusinessMetrics() {
  const responsePromise = await fetch('/businessMetrics.json');

  const response = await responsePromise.json();
  return mapKeys(response, (value, key) => {
    return key.toCamelCase();
  });
}

export default getBusinessMetrics;
